<div class="centerBtn"  *ngIf="exportFlag">
  <mat-form-field appearance="outline">
    <mat-label>Language</mat-label>
    <mat-select [(ngModel)]="selected" (selectionChange)="changeLanguage($event)">
      <mat-option *ngFor="let language of languageList" [value]="language">
        {{ language.desc }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button
    mat-button
    class="btnBlue"
    [matMenuTriggerFor]="menu"
    data-automation-attribute="btn-save"
    style="margin-right: 10px"
  >
    <i class="material-icons"> print </i>
    Export
  </button>

  <mat-menu #menu="matMenu">
    <button
      mat-menu-item
      style="line-height: 30px !important; height: 30px !important"
      *ngFor="let type of exportTypes"
      (click)="exportfile(type)"
    >
      {{ type.desc }}
    </button>
  </mat-menu>
</div>
<div class="center" id="pdfContainer" style="height: 75vh"></div>
